import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { errorBoundary } from "../../../components/general/error-boundary";
import { FIRMA_CONSOLE } from "../../../config";
import { useFeature } from "../../../hooks/use-feature";
import { getCurrentCookieConsents } from "../../../utils/cookie-consent-utils";
import MigratingChildApp from "../../portale-child-app/migrating";

const FirmaDettaglio = ({ auth, company, match, language }) => {
    const enableChildApp = useFeature("FIRMA_CHILD_APP");

    return (
        <MigratingChildApp
            iframeConfigs={{
                data: {
                    cookieConsents: getCurrentCookieConsents(),
                    token: auth.loginAuth.securityToken,
                    itemId: company.base.id,
                    language,
                    route: match.params.batchId && "/list/batchId/" + match.params.batchId
                },
                id: "firma",
                title: "Firma"
            }}
            migrated={enableChildApp}
            url={FIRMA_CONSOLE}
        />
    );
};

function mapStateToProps(state, props) {
    return {
        auth: state.auth,
        company: state.companies.data[props.match.params.item]
            ? state.companies.data[props.match.params.item].item
            : {},
        language: state.user.user ? state.user.user.profile.language : undefined
    };
}

const composedHoc = compose(connect(mapStateToProps), errorBoundary);

export default composedHoc(FirmaDettaglio);
